import React from 'react';

import { PAGE_TITLE } from '../../constants';
import Component from '../../components/operationscheck';
import Container from '../../containers/admin';
import Root from '../../components/root';

export default function PageOperations() {
  return (
    <Root title={PAGE_TITLE.OPERATIONS}>
      <Container>
        <Component />
      </Container>
    </Root>
  );
};
